export const ROUTES = (state) => [
  {
    label: state?.readOnly
      ? 'view_technical_failure'
      : 'resolve_technical_failure',
    link: '',
  },
  {
    label: 'failure_notification_title',
    link: 'additional-functionalities/failure-notification',
  },
  {
    label: 'additional_functionalities',
    link: 'additional-functionalities',
  },
];
